import moment from "moment";
import apiService from "../services/api.service";


export async function getUserProfile() {
    var user_profile = localStorage.getItem("user_profile");
    if(user_profile){
        user_profile = JSON.parse(user_profile);
    }
    console.log("user_profile : %o", JSON.stringify(user_profile));
    if (!user_profile || !user_profile.timestamp || moment().diff(moment(user_profile.timestamp, 'YYYY-MM-DD HH:mm:ss'), "minute") > 5) {
        var response = await apiService({ method: "post", path: "/user/get_user_profile", payload: {} });
        var user_profile = response.data;
        user_profile.timestamp = moment().format('YYYY-MM-DD HH:mm:ss')
        localStorage.setItem("user_profile", JSON.stringify(user_profile));
    } else {
        user_profile = user_profile;
    }
    return user_profile;
}